var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-img"},[_c('img',{attrs:{"src":_vm.src},on:{"click":_vm.view}}),_c('div',{staticClass:"s-img-preview",on:{"click":_vm.view}},[_c('a-icon',{attrs:{"type":"eye"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }